


























































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { EEntities } from '@/types'
import {
  IGenericJSONMessage,
  IProjectsOutputIntegrationsGlipIntegrationInfo,
} from '@/api/types/response.types'

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'
import InternalProjectsAPI from '@/api/modules/internal-projects.api'

export default Vue.extend({
  name: 'GlipIntegrationAccordion',

  props: {
    type: {
      type: String as () => EEntities,
      required: true,
    },
    entityId: {
      type: Number,
      required: true,
    },
    glipIntegration: {
      type: Object as () => IProjectsOutputIntegrationsGlipIntegrationInfo,
      required: true,
    },
  },

  data() {
    return {
      isSubmitting: false,
      isRemoving: false,
      formData: {
        apiToken: '',
      },
    }
  },

  computed: {
    buttonColor(): string {
      return ColorAssistant.getEntityColor(this.type)
    },

    rules() {
      return {
        apiToken: [
          {
            required: true,
            trigger: 'submit',
            message: 'API Token is required',
          },
        ],
      }
    },
  },

  watch: {
    glipIntegration: {
      immediate: true,
      handler(newVal) {
        this.formData.apiToken = newVal.apiToken
      },
    },
  },

  methods: {
    async save(apiToken: string): Promise<IGenericJSONMessage> {
      if (this.type === EEntities.MAILBOXES) {
        return await MailboxesAPI.post_SetGlipIntegration(
          this.entityId,
          apiToken,
        )
      } else {
        return await InternalProjectsAPI.post_SetGlipIntegration(
          this.entityId,
          apiToken,
        )
      }
    },

    async remove(): Promise<IGenericJSONMessage> {
      if (this.type === EEntities.MAILBOXES) {
        return await MailboxesAPI.post_RemoveGlipIntegration(this.entityId)
      } else {
        return await InternalProjectsAPI.post_RemoveGlipIntegration(
          this.entityId,
        )
      }
    },

    async submitHandler() {
      // @ts-ignore
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.isSubmitting = true
          try {
            const response = await this.save(this.formData.apiToken)
            this.$messaging.showSuccess(response.message)
          } catch (err) {
            this.$error.emit(err, true)
          } finally {
            this.isSubmitting = false
          }
        }
      })
    },

    async removeHandler() {
      this.isRemoving = true
      try {
        const response = await this.remove()
        this.$messaging.showSuccess(response.message)
        this.formData.apiToken = ''
      } catch (err) {
        this.$error.emit(err, true)
      } finally {
        this.isRemoving = false
      }
    },
  },
})
